import React from "react";
import { cn } from "@/lib/utils";

const levelClassMap: Record<string, string> = {
  "body-sm": "text-xs",
  "body-xs": "text-[0.6875rem]",
  "body-md": "text-sm",
  "body-lg": "text-base",
  "title-sm": "text-sm font-medium",
  "h4": "text-lg font-semibold",
};

const colorClassMap: Record<string, string> = {
  primary: "text-primary",
  neutral: "text-muted-foreground",
  success: "text-green-600 dark:text-green-400",
  danger: "text-destructive",
  warning: "text-amber-600 dark:text-amber-400",
};

interface HighlightedTextProps {
  text: string;
  searchTerm: string;
  level?: "body-sm" | "body-xs" | "title-sm" | "h4";
  color?: "primary" | "neutral" | "success" | "danger" | "warning";
  className?: string;
}

export const SearchHighlight: React.FC<HighlightedTextProps> = ({
  text,
  searchTerm,
  level = "body-sm",
  color,
  className,
}) => {
  const levelClass = levelClassMap[level] ?? "text-xs";
  const colorClass = color ? colorClassMap[color] : undefined;

  if (!searchTerm || !text) {
    return (
      <span className={cn(levelClass, colorClass, className)}>
        {text}
      </span>
    );
  }

  const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
  const parts = text.split(regex);

  return (
    <span className={cn(levelClass, colorClass, className)}>
      {parts.map((part, index) =>
        regex.test(part) ? (
          <span
            key={index}
            className="bg-amber-200 dark:bg-amber-700 text-amber-900 dark:text-amber-100 font-bold px-0.5 rounded-sm"
          >
            {part}
          </span>
        ) : (
          part
        )
      )}
    </span>
  );
};
